module.exports = __webpack_public_path__ + "static/media/broccoli.ac3907ea.webp";